/* apps/IDSImpactApp/src/app/shared/pdf-viewer/pdf-viewer.component.scss */
#documenteditor_title_contentEditor {
  height: 26px;
  max-width: 75%;
  width: auto;
  overflow: hidden;
  display: inline-block;
  padding-left: 4px;
  padding-right: 4px;
  margin: 5px;
}
.single-line {
  cursor: text !important;
  outline: none;
}
#default_title_bar {
  height: 64px;
  line-height: 26px;
  width: 100%;
  font-size: 12px;
  font-family: inherit;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: inset 0px -1px 0px #e3e3e3;
  border-radius: 5px 5px 0px 0px;
  margin-left: 0;
  margin-right: 0;
}
[class^=e-de-icon-],
[class*=" e-de-icon-"] {
  font-family: "Sample brower icons" !important;
}
.e-de-icon-Print:before {
  content: "\e723";
}
.e-de-icon-Download:before {
  content: "\e728";
}
.save-to-pdf-btn {
  width: 153px !important;
  height: 40px !important;
  background: #41404d !important;
  margin: 12px 3px 12px 12px;
}
.save-btn {
  background: #3e92cc !important;
  width: 96px !important;
  height: 40px !important;
  margin: 12px 15px 12px 12px;
}
.action-right {
  float: right;
}
.action-left {
  float: left;
}
.btn-custom {
  vertical-align: middle !important;
  line-height: 20px !important;
  font-size: 17px !important;
  margin: 22px 0px 22px 0px !important;
}
.center {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  align-items: center;
  text-align: center;
  color: #41404d;
  margin: 20px 0 20px 0 !important;
}
.mat-icon {
  color: #41404d;
}
.pull-right {
  margin: 20px 5px 20px 0px;
  line-height: 7px;
}
/*# sourceMappingURL=pdf-viewer.component.css.map */
